import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../providers/auth';

export const PrivateRoute = () => {
  const { state } = useContext(AuthContext);
  return (
    <>
      {
        state.userIsLogged
          ? <Outlet />
          : <Navigate to={'/'} />
      }
    </>
  );
};
